// components
import Card from '../../../../../components/atoms/card/card'
import RichText from '../../../../../components/atoms/rich-text/rich-text'
import { ArrowDownIcon } from '../../atoms/icons/arrows'
import SearchButton from '../../atoms/searchButton/searchButton'
import '../../organisms/slideOnboarding/styles.scss'
import { IconClose } from '../IconClose'

export const FirstStep = ({ onClick, contentData, gotoNext }) => {
	return (
		<div className='container-item-slider' onClick={gotoNext}>
			<section className='container-item-slider section'>
				<IconClose onClick={onClick} />
				<div>
					<Card classes='morphism'>
						{contentData && <RichText data={contentData} isContent classes='card-text' />}
					</Card>

					<div className='container-icons'>
						<div className='container-arrow__first-step'>
							<ArrowDownIcon />
						</div>
						<SearchButton className='t-a-search-button-initial-position' />
					</div>
				</div>
			</section>
		</div>
	)
}
